import { IPayload } from '@src/models/Global'
import {
  IGetWorkHistoryPositionsParams,
  IWorkHistoryPosition,
} from '@src/models/WorkHistoryPositions'
import { Endpoints } from '../config/endpoints'
import { AxiosService } from '../config/config'

export class WorkHistoryPositionsApi {
  constructor(private axios: AxiosService) {}

  getWorkHistoryPositions = async (params?: IGetWorkHistoryPositionsParams) => {
    const response = await this.axios.get<IPayload<IWorkHistoryPosition[]>>(
      Endpoints.getWorkHistoryPositions,
      params
    )
    return response
  }
}
